import {
  getData,
  postData,
  patchData,
  deleteData
} from './Services'

export const getListaDetPanel = async (searchAofId, searchArtId, page, perPage) => {
  let queryParams = [];
  if (searchAofId) {
    queryParams.push(`lp_id=${encodeURIComponent(searchAofId)}`);
  }
  if (searchArtId) {
    queryParams.push(`art_id=${encodeURIComponent(searchArtId)}`);
  }
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await getData("/artlistasprecios", queryString);
}
export const getListaDetById = async (art_id, lp_id) => { 
  return await getData(
    `/artlistasprecios/${encodeURIComponent(art_id)}/${encodeURIComponent(lp_id)}`
  );
};
export const postListaDet = async (body) => {
  const res = await postData('/artlistasprecios', body)
  return res
}

export const patchListaDet = async (art_id, lp_id, body) => {
  const res = await patchData(`/artlistasprecios/${encodeURIComponent(art_id)}/${encodeURIComponent(lp_id)}`, body)
  return res
}

export const deleteListaDet = async (art_id, lp_id) => {
  const res = await deleteData(`/artlistasprecios/${encodeURIComponent(art_id)}/${encodeURIComponent(lp_id)}`)
  return res
}

export const getArticulos = async () => {
  const res = await getData('/articulos');
  return res
}

export const getArticuloById = async (id) => {
  const res = await getData(`/articulos/${id}`)
  return res
}